import StyleSheetRW from 'core/StyleSheetRW';
import React, { useState } from 'react';
import Chat from 'src/components/Chat';
import Loader from 'src/components/Loader';
import UserList from 'src/components/UserList';
import Menu from './Menu';
import { MOBILE_VIEW_WIDTH } from 'res/constants';
import { Dimensions } from 'react-native';
import userMenuIcon from "res/svgs/userMenuIcon.svg";
import ToastNotification from 'src/components/Toast';

interface User {
    id: string;
    firstName: string;
    email: string;
    lastName: string;
}

const UserChatScreen: React.FC = () => {
    const [selectedUser, setSelectedUser] = useState<User | null>(null);
    const [showLoader, setShowLoader] = useState<boolean>(false);
    const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
    const [isUserMenuIconPosition, setIsUserMenuIconPosition] = useState<boolean>(true);
    const screenWidth = Dimensions.get("window").width;

    const toggleDrawer = () => {
        setDrawerOpen(!drawerOpen);
    };

    const closeDrawer = () => {
        setDrawerOpen(false);
    };

    return (
        <div style={{ display: 'flex', overflow: "hidden", height: "100%"}}>
            <Menu setIsUserMenuIconPosition={setIsUserMenuIconPosition} isUserMenuIconPosition={isUserMenuIconPosition} drawerOpen={drawerOpen}/>
            {/* Drawer button for mobile */}

            {screenWidth <= MOBILE_VIEW_WIDTH && (
                <div
                    style={{
                        width: '27px',
                        height: '27px',
                        position: 'absolute',
                        top: '23px',
                        left: drawerOpen ? undefined : '10px',
                        right: drawerOpen ? 30 : undefined,
                        zIndex: isUserMenuIconPosition ? 1 : -1,
                        cursor: 'pointer',
                    }}
                    onClick={toggleDrawer}
                >
                    <img src={userMenuIcon} alt="userMenuIcon" />

                </div>
            )}

            {/* UserList */}
            {screenWidth <= MOBILE_VIEW_WIDTH && drawerOpen ? (
                <div style={{ width: '100%', transition: 'width 0.5s', position:"absolute", backgroundColor: "rgb(217, 232,222)", height: "100%", overflow: "hidden" }}>
                    <UserList onSelectUser={(user) => { setSelectedUser(user); closeDrawer(); }} setShowLoader={setShowLoader} />
                </div>
            ) : (
                <div style={{ width: '35%', marginBottom: 20, display: screenWidth <= MOBILE_VIEW_WIDTH ? "none" : "block" }}>
                    <UserList onSelectUser={(user) => setSelectedUser(user)} setShowLoader={setShowLoader} />
                </div>
            )}

            {/* Chat */}
            <div style={{ width: screenWidth <= MOBILE_VIEW_WIDTH ? '100%' : "65%" , marginBottom: 20 }}>
                {selectedUser ? (
                    <Chat selectedUser={selectedUser} setShowLoader={setShowLoader} />
                ) : (
                    <div style={styles.container}>
                        <div style={styles.title}>
                            <h3>Please select a user to start chatting</h3>
                        </div>
                    </div>
                )}
            </div>
            {showLoader && <Loader />}
        </div>
    );
};

const styles = StyleSheetRW.create(() => ({
    title: {
        display: "flex", alignItems: "center", justifyContent: "space-between", flexDirection: "column"
    },
    container: {
        display: 'flex', alignItems: "center", justifyContent: "center", height: "100%",
    }
}));

export default UserChatScreen;